<template>
	<div>
		<record :storeId ="storeId" :store ="store" v-if="$route.params.type=='record'"></record>
		<check :storeId ="storeId" :store ="store" v-else></check>
	</div>
</template>

<script>
	import check from '@/components/bar/check/check.vue';
	import record from '@/components/bar/check/checkrecord.vue';
export default {
	components: {check,record},
	props:['storeId','store'],
  	data(){
		return {

		}
	},
	watch:{
	   
	},
	methods:{

	},
	created () {
	},
	mounted() {
		
	},
	beforeDestroy() {

	}
}
</script>
<style lang="scss" scoped>
	@import "index";
</style>


// WEBPACK FOOTER //
// src/components/bar/check/index.vue